import React, { useEffect, useState } from "react";
import { Avatar } from "antd";

import { Images } from "../../config";

const normalizeSource = (src, fallback) => {
  if (
    typeof src !== "string" ||
    !src ||
    src.endsWith("/null") ||
    src.endsWith("null")
  ) {
    return fallback;
  }

  return src;
};

const ProfileImage = ({
  src,
  fallback = Images.DefaultUser,
  asAvatar = false,
  alt = "profile",
  ...props
}) => {
  const [imageSource, setImageSource] = useState(normalizeSource(src, fallback));

  useEffect(() => {
    setImageSource(normalizeSource(src, fallback));
  }, [src, fallback]);

  const handleError = () => {
    if (imageSource !== fallback) {
      setImageSource(fallback);
    }

    return false;
  };

  if (asAvatar) {
    return <Avatar src={imageSource} onError={handleError} {...props} />;
  }

  return (
    <img
      src={imageSource}
      alt={alt}
      onError={handleError}
      {...props}
    />
  );
};

export default ProfileImage;
